import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#111827" }, // серо-черный
    secondary: { main: "#2563eb" }, // синий
  },
  shape: { borderRadius: 5 },
});

export default theme;
